import angular from 'angular';
import TableService from './table.service';

export default angular.module('autoboard.tables', [TableService])
  .name;
